import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import InfoIcon from '@material-ui/icons/Info';
import EditIcon from '@material-ui/icons/Edit';
import Menu from 'modules/shared/components/_controls/Menu/Menu';
import ConfirmDialogComponent from 'modules/shared/components/confirm-dialog/ConfirmDialogComponent';
import DepartmentDialogContainer from '../department-dialog/DepartmentDialogContainer';
import LoadingState from 'modules/shared/components/_states/LoadingState/LoadingState';
import EmptyDepartmentImg from 'assets/img/app_states/empty/Skills.png';
import EmptyState from 'modules/shared/components/_states/EmptyState/EmptyState';
import Button from '@material-ui/core/Button';
const DepartmentsList = props => {
  return (
    <div id="DepartmentsList">
      {!props.isLoading ? (
        props.departments.length > 0 ? (
          <div className="departmentsContainer">
            {props.departments.map((department, idx) => (
              <div key={idx} className="departmentCard">
                <div className="departmentCardHeader">
                  <div className="departmentCardTitle">{department.name}</div>
                  <div className="menuContainer">
                    <Menu>
                      <div
                        className="CustommenuItem"
                        onClick={() => {
                          props.openSideContent(department);
                          props.openDrawer?.();
                        }}
                      >
                        <InfoIcon />
                        <span style={{ marginLeft: '16px' }}>Info</span>
                      </div>
                      <div
                        className="CustommenuItem"
                        onClick={() => props.openDepartmentDialog(department)}
                      >
                        <EditIcon />
                        <span style={{ marginLeft: '16px' }}>Edit</span>
                      </div>
                    </Menu>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <EmptyState
            stateImage={
              <div>
                <img src={EmptyDepartmentImg} alt="" />
              </div>
            }
            stateText={
              <div className="empty-text-section">
                <div
                  style={{ marginBottom: '0.75em', font: '400 15px/24px' }}
                  className="empty-text-message"
                >
                  You don't have any departments yet.
                </div>
                <div className="empty-text-action" style={{ textAlign: 'center' }}>
                  <Button
                    style={{ position: 'static', textTransform: 'unset' }}
                    onClick={() => props.openDepartmentDialog()}
                    variant="contained"
                    color="primary"
                  >
                    Create new department
                  </Button>
                </div>
              </div>
            }
          />
        )
      ) : (
        <LoadingState />
      )}

      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={props.isDialogOpen}
        onBackdropClick={props.closeDepartmentDialog}
        aria-labelledby="form-dialog-title"
      >
        <DepartmentDialogContainer
          data={props.dialogData}
          closeDialog={props.closeDepartmentDialog}
          onDepartmentCreate={props.onDepartmentCreate}
        />
      </Dialog>

      <Dialog open={props.isDeleteDialogOpen} onBackdropClick={props.closeDeleteDialog}>
        <ConfirmDialogComponent data={props.toDelete} close={props.closeDeleteDialog} />
      </Dialog>

      <Snackbar
        open={props.showSuccessToast}
        autoHideDuration={1000}
        onClose={props.closeSuccessToast}
      >
        <Alert onClose={props.closeSuccessToast} severity={'success'}>
          {props.successToastText}
        </Alert>
      </Snackbar>

      <Snackbar open={props.showErrorToast} autoHideDuration={1000} onClose={props.closeErrorToast}>
        <Alert onClose={props.closeErrorToast} severity={'error'}>
          {props.errorToastText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default DepartmentsList;
